var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-1",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":12}},[_vm._v(" Please contact me on the following social media platforms: ")])],1),_c('v-row',[_c('v-col',[_c('LinkedInProfileBadge')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }